module.exports = __webpack_public_path__ + "assets/fa6af9b5bbacec898dd64f406c2fe746.png";